import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi, getOrgId } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/UpdateUserRoles";

export function* updateUserRoles(action: Actions.UpdateUserRolesAction) {
    const { payload } = action;
    const { credentials, options, organizationId, userId } = payload;
    const realOrganizationId: string = getOrgId(organizationId);

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const user = yield api.updateUserRolesInOrganization(userId, realOrganizationId, options);
        yield put(addNotification(`${user.email} updated`));
        yield put(Actions.updateUserRolesEnd(undefined, realOrganizationId, user));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.updateUserRolesEnd(e, realOrganizationId));
    } finally {
        yield put(loading(false, action));
    }
}
export function* watchUpdateUserRoles() {
    yield takeEvery(Actions.UPDATE_USER_ROLES, updateUserRoles);
}
